import { Component } from '@angular/core';

@Component({
  selector: 'cert-pd-advanced-person-search-actions-cell-renderer',
  templateUrl: './pd-advanced-person-search-actions-cell-renderer.component.html',
  styles: ``,
  standalone: false,
})
export class ProfessionalDevelopmentAdvancedPersonSearchActionsCellRenderer {
  params: any;

  agInit(params: any): void {
    this.params = params;
  }

  select() {
    this.params.context.componentParent.onSelect(this.params.data);
  }

  refresh(params: any): boolean {
    return false;
  }
}
